import * as React from 'react'
import { useContextSelector } from 'use-context-selector'
import { AppCalendarContext } from '../Providers'
import { AppTooltip } from '../../Base'
import './PriceByNight.css'


// Toggle Price/night del calendar — mismo chip de texto activable que el toolbar de las
// tablas del Competition Analyzer (antes era un SwitchSeeker "Prices total / Prices by night").
export default function AppCalendarPriceByNight() {
    const priceByNight = useContextSelector(AppCalendarContext, ({ state }) => state.priceByNight)
    const updateCalendar = useContextSelector(AppCalendarContext, ({ updateState }) => updateState)

    return <AppTooltip title="Divide price by night for LOS (minimum stay) results">
        <div
            className={`competition-toolbar__check ${!priceByNight ? 'competition-toolbar__check--inactive' : ''}`}
            onClick={() => updateCalendar({ priceByNight: !priceByNight })}
        >
            <span className="competition-toolbar__dot" style={{ backgroundColor: '#2474b2' }} />
            <span>Price/night</span>
        </div>
    </AppTooltip>
}
